import { render, staticRenderFns } from "./coreServe.vue?vue&type=template&id=da0cdca0&scoped=true"
import script from "./coreServe.vue?vue&type=script&lang=js"
export * from "./coreServe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da0cdca0",
  null
  
)

export default component.exports